'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onPlay", "onPause", "onReady", "onLoaded", "loadingBackground", "placeholderAspectRatio", "color"];
import { withTheme } from 'foundations-theming/utils';
import { Component } from 'react';
import Wrapper from '../components/StyledComponents/Wrapper';
import LoadingContainer from '../components/LoadingContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HELP_TEXT_TIMEOUT = 1000 * 5;
const PAUSE_TIMEOUT = 1000;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
export default function withPauseAndHelpLogic(WrappedComponent) {
  class WithPauseAndHelpLogicWithoutTheme extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isReady: false,
        isLoaded: false,
        displayHelpText: false
      };
      this.startHelpTextTimeout = this.startHelpTextTimeout.bind(this);
      this.cancelHelpTextTimeout = this.cancelHelpTextTimeout.bind(this);
      this.handlePause = this.handlePause.bind(this);
      this.actuallyHandlePause = this.actuallyHandlePause.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handleReady = this.handleReady.bind(this);
      this.handleLoaded = this.handleLoaded.bind(this);
      this.handleChangeVideo = this.handleChangeVideo.bind(this);
    }
    componentDidMount() {
      this.startHelpTextTimeout();
    }
    componentWillUnmount() {
      this.cancelTrackPauseTimeout();
      this.cancelHelpTextTimeout();
    }
    startHelpTextTimeout() {
      this.setState({
        displayHelpText: false
      });
      this.cancelHelpTextTimeout();
      this.displayHelpTextTimeoutId = window.setTimeout(() => {
        this.setState({
          displayHelpText: true
        });
      }, HELP_TEXT_TIMEOUT);
    }
    cancelHelpTextTimeout() {
      clearTimeout(this.displayHelpTextTimeoutId);
    }
    cancelTrackPauseTimeout() {
      clearTimeout(this.trackPauseTimeout);
      this.trackPauseTimeout = false;
    }
    handlePause() {
      this.cancelTrackPauseTimeout();
      this.trackPauseTimeout = window.setTimeout(this.actuallyHandlePause, PAUSE_TIMEOUT);
    }
    actuallyHandlePause() {
      const {
        onPause
      } = this.props;
      if (onPause) {
        onPause();
      }
      this.cancelTrackPauseTimeout();
    }
    handlePlay() {
      const {
        onPlay
      } = this.props;
      if (!this.trackPauseTimeout) {
        if (onPlay) {
          onPlay();
        }
      } else {
        this.cancelTrackPauseTimeout();
      }
    }
    handleReady() {
      const {
        onReady
      } = this.props;
      this.setState({
        isReady: true
      });
      if (onReady) {
        onReady();
      }
    }
    handleLoaded() {
      const {
        onLoaded
      } = this.props;
      this.setState({
        isLoaded: true
      });
      if (onLoaded) {
        onLoaded();
      }
    }
    handleChangeVideo() {
      this.setState({
        isReady: false
      });
    }
    render() {
      const {
        displayHelpText,
        isReady
      } = this.state;
      const _this$props = this.props,
        {
          // eslint-disable-line no-unused-vars
          // eslint-disable-line no-unused-vars
          // eslint-disable-line no-unused-vars
          // eslint-disable-line no-unused-vars
          loadingBackground,
          placeholderAspectRatio,
          color
        } = _this$props,
        passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsxs(Wrapper, {
        isReady: isReady,
        placeholderAspectRatio: placeholderAspectRatio,
        loadingBackground: loadingBackground || this.props.theme.color['do-not-use-olaf'],
        children: [!this.state.isLoaded && /*#__PURE__*/_jsx(LoadingContainer, {
          displayHelpText: displayHelpText
        }), /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
          startHelpTextTimeout: this.startHelpTextTimeout,
          cancelHelpTextTimeout: this.cancelHelpTextTimeout,
          onPause: this.handlePause,
          onPlay: this.handlePlay,
          onReady: this.handleReady,
          onChangeVideo: this.handleChangeVideo,
          onLoaded: this.handleLoaded,
          color: color || this.props.theme.color['fill-accent-orange-default']
        }, passThroughProps))]
      });
    }
  }
  WithPauseAndHelpLogicWithoutTheme.defaultProps = {
    videoPlaySpeed: 100,
    placeholderAspectRatio: 16 / 9
  };
  const WithPauseAndHelpLogic = withTheme(WithPauseAndHelpLogicWithoutTheme);
  WithPauseAndHelpLogic.displayName = `WithPauseAndHelpLogic(${getDisplayName(WrappedComponent)})`;
  return WithPauseAndHelpLogic;
}